import { React } from 'react';
import Hero from './components/Hero';
import './styles/media.scss';
import MediaMain from './components/hero-items/MediaMain';
import ReactGA from 'react-ga';
import Pengu from './components/Pengu';

const Media = () => (
        <div className="media-container">
            <Hero className="home"
            first="/img/keyart/banner-first.jpg" 
            second ="/img/keyart/banner-second.jpg" 
            gradOne=".25turn, rgba(183,280, 255, 0), rgba(183,280, 255, .75) , #E9F0AA)"
            gradTwo=".75turn, rgba(0,0,0,0) , rgba(248,240, 200, .75), #E9F0AA) "
            contents={<MediaMain />}
            size = "450px"/>
            <div className="media-contents">
                <div className="trailer-wrapper" id="trailer-container">
                    <h1 className="trailer-title">LAUNCH TRAILER</h1>
                    <div className="video-wrapper">
                        <div className="video">
                            <div className="trailer-container">
                                <iframe src="https://www.youtube.com/embed/MiYj1Wp5OZE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <h1 className="trailer-title">ANNOUNCEMENT TRAILER</h1>
                    <div className="video-wrapper">
                        <div className="video">
                            <div className="trailer-container">
                                <iframe src="https://www.youtube.com/embed/-MnE17o-U58?rel=0&showinfo=0&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <h1 className="trailer-title">PHANTOM BRAVE TRAILER</h1>
                    <div className="video-wrapper">
                        <div className="video">
                            <div className="trailer-container">
                                <iframe src="https://www.youtube.com/embed/0epZmtoG15Y?rel=0&amp;showinfo=0&amp;modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <h1 className="trailer-title">SOUL NOMAD TRAILER</h1>
                    <div className="video-wrapper">
                        <div className="video">
                            <div className="trailer-container">
                                <iframe src="https://www.youtube.com/embed/m6bLK8C4A_4?rel=0&showinfo=0&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="wallpaper-container" id="wallpaper-container">
                    <div className="wallpaper-section">
                        <h1 className="wallpaper-title">PHANTOM BRAVE WALLPAPERS</h1>
                        <div className="wallpaper">
                            <div className="wallpaper-art">
                                <img src="img/wallpapers/PC2160_PB01.jpg" alt="For Her Sake Wallpaper"/>
                            </div>
                            <div className="wallpaper-body">
                                <h1 className="wallpaper-tag">
                                    Download "For Her Sake"
                                </h1>
                                <div className="wallpaper-links link-width">
                                    <a target="_blank" href="img/wallpapers/PC1600_PB01.jpg" 
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - PC1600_PB01'
                                        })}}
                                    ><button className="store-link">2560 × 1600</button></a>
                                    <a target="_blank" href="img/wallpapers/PC2160_PB01.jpg" 
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - PC2160_PB01'
                                        })}}
                                    ><button className="store-link">3840 × 2160</button></a>
                                    <a target="_blank" href="img/wallpapers/Mobile_PB01.jpg"  
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - Mobile_PB01'
                                        })}}
                                    ><button className="store-link">Mobile</button></a>
                                </div>
                            </div>
                        </div>
                        <div className="wallpaper">
                            <div className="wallpaper-art">
                                <img src="img/wallpapers/PC2160_PB02.jpg" alt="For Her Sake Wallpaper"/>
                            </div>
                            <div className="wallpaper-body">
                                <h1 className="wallpaper-tag">
                                    Download "Friends"
                                </h1>
                                <div className="wallpaper-links link-width">
                                    <a target="_blank" href="img/wallpapers/PC1600_PB02.jpg"  
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - PC1600_PB02'
                                        })}}
                                    ><button className="store-link">2560 × 1600</button></a>
                                    <a target="_blank" href="img/wallpapers/PC2160_PB02.jpg" 
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - PC2160_PB02'
                                        })}}
                                    ><button className="store-link">3840 × 2160</button></a>
                                    <a target="_blank" href="img/wallpapers/Mobile_PB02.jpg" 
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - Mobile_PB02'
                                        })}}
                                    ><button className="store-link">Mobile</button></a>
                                </div>
                            </div>
                        </div>
                        <div className="wallpaper">
                            <div className="wallpaper-art">
                                <img src="img/wallpapers/PC2160_PB03.jpg" alt="For Her Sake Wallpaper"/>
                            </div>
                            <div className="wallpaper-body">
                                <h1 className="wallpaper-tag">
                                    Download "Adorable Allies"
                                </h1>
                                <div className="wallpaper-links link-width">
                                    <a target="_blank" href="img/wallpapers/PC1600_PB03.jpg" 
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - PC1600_PB03'
                                        })}}
                                    ><button className="store-link">2560 × 1600</button></a>
                                    <a target="_blank" href="img/wallpapers/PC2160_PB03.jpg"
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - PC2160_PB03'
                                        })}}
                                    ><button className="store-link">3840 × 2160</button></a>
                                    <a target="_blank" href="img/wallpapers/Mobile_PB03.jpg"
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - Mobile_PB03'
                                        })}}
                                    ><button className="store-link">Mobile</button></a>
                                </div>
                            </div>
                            
                        </div>
                        <div className="wallpaper">
                            <div className="wallpaper-art">
                                <img src="img/wallpapers/PC2160_PB04.jpg" alt="For Her Sake Wallpaper"/>
                            </div>
                            <div className="wallpaper-body">
                                <h1 className="wallpaper-tag">
                                    Download "Island Adventures"
                                </h1>
                                <div className="wallpaper-links link-width">
                                    <a target="_blank" href="img/wallpapers/PC1600_PB04.jpg" 
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - PC1600_PB04'
                                        })}}
                                    ><button className="store-link">2560 × 1600</button></a>
                                    <a target="_blank" href="img/wallpapers/PC2160_PB04.jpg"
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - PC2160_PB04'
                                        })}}
                                    ><button className="store-link">3840 × 2160</button></a>
                                    <a target="_blank" href="img/wallpapers/Mobile_PB04.jpg" 
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - Mobile_PB04'
                                        })}}
                                    ><button className="store-link">Mobile</button></a>
                                </div>
                            </div>
                            
                        </div>
                    
                        <h1 className="wallpaper-title">SOUL NOMAD WALLPAPERS</h1>
                        <div className="wallpaper">
                            <div className="wallpaper-art">
                                <img src="img/wallpapers/PC1600_SN01.jpg" alt="For Her Sake Wallpaper"/>
                            </div>
                            <div className="wallpaper-body">
                                <h1 className="wallpaper-tag">
                                    Download "Training Buddies"
                                </h1>
                                <div className="wallpaper-links link-width">
                                    <a target="_blank" href="img/wallpapers/PC1600_SN01.jpg" 
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - PC1600_SN01'
                                        })}}
                                    ><button className="store-link">2560 × 1600</button></a>
                                    <a target="_blank" href="img/wallpapers/PC2160_SN01.jpg"
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - PC2160_SN01'
                                        })}}
                                    ><button className="store-link">3840 × 2160</button></a>
                                    <a target="_blank" href="img/wallpapers/Mobile_SN01.jpg" 
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - Mobile_SN01'
                                        })}}
                                    ><button className="store-link">Mobile</button></a>
                                </div>
                            </div>
                        </div>
                        <div className="wallpaper">
                            <div className="wallpaper-art">
                                <img src="img/wallpapers/PC1600_SN02.jpg" alt="For Her Sake Wallpaper"/>
                            </div>
                            <div className="wallpaper-body">
                                <h1 className="wallpaper-tag">
                                    Download "Fate of the World"
                                </h1>
                                <div className="wallpaper-links link-width">
                                    <a target="_blank" href="img/wallpapers/PC1600_SN02.jpg" 
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - PC1600_SN02'
                                        })}}
                                    ><button className="store-link">2560 × 1600</button></a>
                                    <a target="_blank" href="img/wallpapers/PC2160_SN02.jpg"
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - PC2160_SN02'
                                        })}}
                                    ><button className="store-link">3840 × 2160</button></a>
                                    <a target="_blank" href="img/wallpapers/Mobile_SN02.jpg" 
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - Mobile_SN02'
                                        })}}
                                    ><button className="store-link">Mobile</button></a>
                                </div>
                            </div>
                        </div>
                        <div className="wallpaper">
                            <div className="wallpaper-art">
                                <img src="img/wallpapers/PC1600_SN03.jpg" alt="For Her Sake Wallpaper"/>
                            </div>
                            <div className="wallpaper-body">
                                <h1 className="wallpaper-tag">
                                    Download "Battle Ready"
                                </h1>
                                <div className="wallpaper-links link-width">
                                    <a target="_blank" href="img/wallpapers/PC1600_SN03.jpg" 
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - PC1600_SN03'
                                        })}}
                                    ><button className="store-link">2560 × 1600</button></a>
                                    <a target="_blank" href="img/wallpapers/PC2160_SN03.jpg"
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - PC2160_SN03'
                                        })}}
                                    ><button className="store-link">3840 × 2160</button></a>
                                    <a target="_blank" href="img/wallpapers/Mobile_SN03.jpg" 
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - Mobile_SN03'
                                        })}}
                                    ><button className="store-link">Mobile</button></a>
                                </div>
                            </div>
                        </div>
                        <div className="wallpaper">
                            <div className="wallpaper-art">
                                <img src="img/wallpapers/PC1600_SN04.jpg" alt="For Her Sake Wallpaper"/>
                            </div>
                            <div className="wallpaper-body">
                                <h1 className="wallpaper-tag">
                                    Download "Commander of the World Eaters"
                                </h1>
                                <div className="wallpaper-links link-width">
                                    <a target="_blank" href="img/wallpapers/PC1600_SN04.jpg" 
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - PC1600_SN04'
                                        })}}
                                    ><button className="store-link">2560 × 1600</button></a>
                                    <a target="_blank" href="img/wallpapers/PC2160_SN04.jpg" 
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - PC2160_SN04'
                                        })}}
                                    ><button className="store-link">3840 × 2160</button></a>
                                    <a target="_blank" href="img/wallpapers/Mobile_SN04.jpg" 
                                        onClick={
                                            ()=>{ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'Wallpaper - Mobile_SN04'
                                        })}}
                                    ><button className="store-link">Mobile</button></a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>    
            <Pengu link="./products"/>
        </div>
);


export default Media;